import getIn from 'lodash/get';
import isFunction from 'lodash/isFunction';

/**
 * @param  {Function} handler - a DOM event handler function to wrap
 * @returns {Function} - the handler function in a wrapper function
 *                      that stops DOM event propagation before it calls the original handler
 */
export function handlerNoPropagate(handler) {
  return e => {
    e.stopPropagation();
    handler(e);
  };
}

export function parseTrackingEvents(events) {
  const eventMapping = {};
  let error = false;
  events.forEach(event => {
    if (!event.type || !event.urls) {
      error = true;
      return;
    }
    eventMapping[event.type] = event.urls;
  });
  if (error) {
    return null;
  }
  return eventMapping;
}

export function preventDefaultAndCall(fn) {
  return e => {
    e.preventDefault();
    fn(e);
  };
}

export function attemptComponentEventNotification(handler, notifier, eventData) {
  if (isFunction(handler) && isFunction(notifier)) {
    return e => {
      const destinationUrl = getIn(e, 'currentTarget.pathname');
      const data = isFunction(eventData) ? eventData() : eventData;
      if (destinationUrl) {
        notifier({ ...{ destinationUrl }, ...data });
      } else {
        notifier(data);
      }
      handler(e);
    };
  }
  return handler;
}
